import styled from 'styled-components';
import { HeaderButton } from '../../styles/globals';

export const DownloadButton = styled(HeaderButton)``;

export const IconCont = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DownloadButtonCont = styled.div`
  position: absolute;
  top: 0;
  right: 24px;
  z-index: 1000;
`;
